<template>
  <div>
    <Header />
    <form
      class="needs-validation"
      id="cart-form"
      ref="cartform"
      style="padding-top: 4rem"
      @submit.prevent="handleSubmit"
      novalidate
    >
      <Order
        :order="order"
        :cartItems="$store.state.cart"
        :deliveryType="deliveryType"
        v-on:deliveryChange="deliveryChange($event)"
      />
      <div class="container">
        <div class="form-group row"></div>
        <div class="form-group row">
          <div class="col-sm-4"></div>
          <div class="col-sm-8">
            <div style="font-size: 0.7rem">
              Tento web je chráněn službou reCAPTCHA a aplikují zde
              <a href="https://policies.google.com/privacy" target="_blank"
                >Zásady ochrany osobních údajů</a
              >
              a
              <a href="https://policies.google.com/terms" target="_blank"
                >Smluvní podnímky</a
              >
              společnosti Goolge.
            </div>
            <button
              id="orderBtn"
              type="submit"
              class="btn btn-success"
              style="float: right; margin-top: 1rem"
              :disabled="loading"
            >
              <font-awesome-icon v-if="loading" :icon="['fas', 'spinner']" class="fa-spin" /> 
              <font-awesome-icon v-if="!loading" :icon="['fas', 'shopping-cart']" /> 
              Objednat
            </button>
            <!-- Do NOT use name="submit" or id="submit" for the Submit button -->
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import Order from "./Order";
import Header from "./../templates/Header";

export default {
  name: "Cart",
  components: {
    Order,
    Header,
  },
  data: function () {
    return {
      deliveryType: null,
      order: { deliveryAddressSame: true, agreeMarketing: true },
      errorMessage: "",
      errorShow: false,
      loading: false
    };
  },
  methods: {
    updateTransport: function () {
      this.$store.dispatch("updateTransport", this.deliveryType);
    },
    // async recaptcha() {
    //   // (optional) Wait until recaptcha has been loaded.
    //   await this.$recaptchaLoaded();

    //   // Execute reCAPTCHA with action "login".
    //   const token = await this.$recaptcha("login");

    //   // Do stuff with the received token.
    //   this.recaptchaToken = token;
    // },
    isTransport: function (item) {
      return item.item.image === "transport";
    },
    getVariantName: function (name) {
      if (name === "DELIVERY") {
        return "Rozvoz po Praze";
      } else if (name === "PERSONAL") {
        return "Osobní odběr";
      } else {
        return name;
      }
    },
    deliveryChange: function (newValue) {
      this.deliveryType = newValue;
      this.updateTransport();
    },
    handleSubmit: function (event) {
      event.preventDefault();
      var self = this;
      if (this.$refs.cartform.checkValidity() === false) {
        event.stopPropagation();
      } else {
        this.loading = true;
        this.$recaptchaLoaded().then(() => {
          this.$recaptcha("login").then((recaptchaToken) => {
            if (recaptchaToken === null) {
              throw new Error("Recaptcha nebyla přijata.");
            }
            this.order.zip = this.order.zip.replace(/\s/g, "");

            this.order.recaptchaToken = recaptchaToken;
            this.$store
              .dispatch("order", this.order)
              .then(() => {
                this.$router.push({ name: "thanks" });
              })
              .catch((err) => {
                self.$store.commit("addNotification", {
                  text: "Chyba objednávky. " + err.message,
                  type: "alert",
                });

                this.loading = false;
              });
          });
        });
      }
      this.$refs.cartform.classList.add("was-validated");
    },
  },
  mounted() {
    let self = this;
    this.$store
      .dispatch("fetchCart", { self: this })
      .then(() => {
        if (self.$store.state.cart.length === 0) {
          this.$router.push("/");
          self.$store.commit("addNotification", {
            text: "Váš košík je prázdný",
            type: "alert",
            // timeout not specified - defaults to true
            // delay not specified, defaults to 3000
          });
        }
      })
      .catch((err) => {
        self.$store.commit("addNotification", {
          text: "Chyba načtení položek košíku. " + err.message,
          type: "alert",
        });
      });
  },
};
</script>